import { createStore } from "solid-js/store";

import {
  postGetActivityConfig,
  postGetActivityDetails,
} from "@/api/clientApi/activity";
import {
  // TournamentConfigTypes,
  TournamentItemTypes,
  TournamentTypes,
} from "@/pages/pc/tournament/types";
import { ActivityTypeEnum } from "@/types/compontent/base/baseEnum";

type TournamentStoreTypes = {
  /** 当前选中 tab , 1: 进行中, 2: 即将开始, 3: 已结束 */
  tabActive: TournamentTypes;
  /** 赛事列表 */
  events: TournamentItemTypes[];
  /** 是否加载中 */
  isLoading: boolean;
  /** 赛事配置 */
  // tournamentCfg: TournamentConfigTypes | null;
  /** 赛事详情 */
  tournamentItem: TournamentItemTypes[] | [];
};

const defaultTournamentStore: TournamentStoreTypes = {
  tabActive: 1,
  events: [],
  isLoading: false,
  // tournamentCfg: null,
  tournamentItem: [],
};

/* prettier-ignore  */
export const [tournamentStore, setTournamentStore] = createStore<TournamentStoreTypes>(defaultTournamentStore);

// 修正 tab 值
export const onChangeTournamentTab = (tab: number) => {
  setTournamentStore("tabActive", tab);
};

// 修正赛事列表
export const onChangeTournamentItems = (items: TournamentItemTypes[]) => {
  setTournamentStore("events", items);
};

// 已登入
export const getLoginTournamentConfig = async () => {
  try {
    setTournamentStore("isLoading", true);
    const res = await postGetActivityDetails({
      atypes: [ActivityTypeEnum.tournament],
    });
    console.log("res-login", res);
    if (res?.activity_details?.[ActivityTypeEnum.tournament]?.details?.races) {
      setTournamentStore(
        "tournamentItem",
        res?.activity_details?.[ActivityTypeEnum.tournament]?.details
          ?.races as unknown as TournamentItemTypes,
      );
    } else {
      setTournamentStore("tournamentItem", []);
    }
  } catch (error) {
    console.error("Failed to fetch tournament config:", error);
  } finally {
    setTournamentStore("isLoading", false);
  }
  return;
};

// 未登入
export const getNoLoginTournamentConfig = async () => {
  try {
    setTournamentStore("isLoading", true);

    const res = await postGetActivityConfig(ActivityTypeEnum.tournament);
    if (res?.activity_cfg_list?.[0]?.cfg?.races) {
      setTournamentStore(
        "tournamentItem",
        res?.activity_cfg_list?.[0]?.cfg
          ?.races as unknown as TournamentItemTypes,
      );
    } else {
      setTournamentStore("tournamentItem", []);
    }
  } catch (error) {
    console.error("Failed to fetch tournament config:", error);
  } finally {
    setTournamentStore("isLoading", false);
  }
  return;
};
